import { motion } from "motion/react";
import { DigitalService } from "../../data/pricing-data";

interface DigitalServiceCardProps {
  service: DigitalService;
  index: number;
}

export function DigitalServiceCard({ service, index }: DigitalServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="bg-gradient-to-br from-violet-950/40 via-fuchsia-950/40 to-cyan-950/40 rounded-2xl p-6 border border-violet-500/20 hover:border-violet-400/50 transition-all duration-300"
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xl font-bold text-white">{service.name}</h3>
        <span className="text-2xl font-bold text-violet-400">{service.price}</span>
      </div>
      <p className="text-gray-400 mb-4">{service.description}</p>
      <a
        href="/contact"
        className="inline-block px-6 py-2 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white rounded-lg font-semibold hover:from-violet-500 hover:to-fuchsia-500 transition-all duration-300"
      >
        Learn More
      </a>
    </motion.div>
  );
}